import { render, staticRenderFns } from "./DisplayRating.vue?vue&type=template&id=0ebec7a5&scoped=true&"
import script from "./DisplayRating.vue?vue&type=script&lang=js&"
export * from "./DisplayRating.vue?vue&type=script&lang=js&"
import style0 from "./DisplayRating.vue?vue&type=style&index=0&id=0ebec7a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebec7a5",
  null
  
)

export default component.exports